import baseApi from '@/helpers/baseApi';

const apiUrl = process.env.API_URL;

/** The public settings of the service (the admin panel, "Service settings"): the values by the keys */
export type PublicSettings = Partial<Record<string, number | string | boolean>>;

/** The register of the uploads (FOR-2710): the formats of the places where a user uploads a file and the key of the setting with the size limit */
export interface UploadPlace {
  extensions: string[],
  maxSizeSetting?: string,
  connected: boolean
}
export type PublicUploads = Record<string, UploadPlace>;

// the value used until the settings are loaded (or when they are not available): the default value of the service
export const defaultAttachmentMaxSizeMb = 10;
export const defaultAiTemplateFileMaxSizeMb = 5;
export const defaultMassRenderMaxRows = 1000;

// FOR-2710, stage 2: the number of the attachments of a document
export const defaultAttachmentMaxCount = 10;

// the limits of the length of the names, chars (the group "Length limits"): the key of the setting -> the default value (the same as in the service)
export const defaultLengthLimit = {
  'limits.documentNameLength': 255,
  'limits.templateNameLength': 100,
  'limits.folderNameLength': 100,
  'limits.attachmentNameLength': 255,
  'limits.productTextLength': 500,
} as const;
export type LengthLimitKey = keyof typeof defaultLengthLimit;

// the size limits of the uploads (FOR-2710, stage 1): the key of the setting -> the default value, MB (the same as in the service)
export const defaultUploadMaxSizeMb = {
  'import.wordMaxSizeMb': 10,
  'import.tableMaxSizeMb': 1,
  'masscreate.fileMaxSizeMb': 2,
  'editor.colontitulImageMaxSizeMb': 1,
  'editor.imageMaxSizeMb': 1,
  'facsimile.maxSizeMb': 1,
  'mchd.maxSizeMb': 1,
} as const;
export type UploadSizeKey = keyof typeof defaultUploadMaxSizeMb;

const settingsPublicApi = {
  getPublicSettings: () => baseApi.get<PublicSettings>(`${apiUrl}/settingspublic`),
  getPublicUploads: () => baseApi.get<PublicUploads>(`${apiUrl}/uploadspublic`)
};

export default settingsPublicApi;
